/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { toast } from "react-toastify";

import api from "../../../../../services/axiosConfig";

function ModalNovaMensagem({ isOpen, onClose, mensagemSelecionada }) {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [tipoConta, setTipoConta] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (mensagemSelecionada) {
      setTitle(mensagemSelecionada?.title);
      setBody(mensagemSelecionada?.body);
      setTipoConta(mensagemSelecionada?.tipoConta || "");
    } else {
      setTitle("");
      setBody("");
      setTipoConta("");
    }
  }, [mensagemSelecionada, isOpen]);

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    const messageData = { title, body, tipoConta: tipoConta || null };

    try {
      if (mensagemSelecionada) {
        await api.put(
          `/mensagens/${mensagemSelecionada._id}/editar`,
          messageData
        );
        toast.success("Mensagem atualizada com sucesso!");
      } else {
        await api.post("/mensagens/criar-mensagem", messageData);
        toast.success("Mensagem criada com sucesso!");
      }
      onClose();
    } catch (error) {
      console.error("Erro ao salvar mensagem:", error);
      toast.error("Ocorreu um erro ao salvar a mensagem.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered style={{ maxWidth: 600 }}>
      <Form onSubmit={handleSubmit}>
        <ModalHeader toggle={onClose}>
          {mensagemSelecionada ? "Editar Mensagem" : "Criar Nova Mensagem"}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="title">Título</Label>
            <Input
              id="title"
              name="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="body">Corpo da Mensagem</Label>
            <Input
              id="body"
              name="body"
              type="textarea"
              rows={5}
              value={body}
              onChange={(e) => setBody(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="tipoConta">
              Segmentar por Tipo de Conta (opcional)
            </Label>
            <Input
              id="tipoConta"
              name="tipoConta"
              type="select"
              value={tipoConta}
              onChange={(e) => setTipoConta(e.target.value)}
            >
              <option value="">Para Todos os Usuários</option>
              <option value="usuario">Cortador</option>
              <option value="influenciador">Influenciador</option>
              <option value="afiliado">Afiliado</option>
            </Input>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button color="primary" type="submit" disabled={isLoading}>
            {isLoading ? "Salvando..." : "Salvar Mensagem"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default ModalNovaMensagem;
